// extracted by mini-css-extract-plugin
module.exports = {"usDollarsNotice":"_23OGJ"};